import * as React from "react";
import { SVGProps } from "react";

const SvgFee = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 270 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M243.139 125.802c-8.008-7.956-18.291-5.158-22.833-2.454l-35.131 16.955c.303-1.681.481-3.529.481-5.564 0-15.16-9.48-20.766-9.877-20.996l-1.065-.615h-61.231c-25.025-14.731-48.88-3.174-54.529 0H30.547v9.229h25.046v61.085H28.887v9.229h142.111l1.012-.533c2.402-1.263 58.883-31.122 68.874-37.114 6.097-3.665 7.903-8.718 8.341-12.309.804-6.703-2.474-13.322-6.086-16.913Zm-3.09 15.806c-.282 2.287-1.566 4.093-3.926 5.513-9.062 5.439-59.602 32.197-67.422 36.331H64.821v-62.996c6.286-3.215 25.339-10.941 44.945 1.212l1.118.689h61.043c1.493 1.378 4.489 5.042 4.489 12.382 0 7.318-2.975 10.607-4.322 11.713h-54.852v9.229h57.284l.951-.459 49.037-23.657.396-.22c.679-.407 6.839-3.862 11.725 1.003 1.962 1.952 3.831 5.867 3.414 9.26Zm-200.576 38.19c7.465 0 13.541-6.076 13.541-13.551 0-7.465-6.076-13.551-13.54-13.551-7.465 0-13.552 6.076-13.552 13.551 0 7.475 6.076 13.551 13.551 13.551Zm0-17.863a4.331 4.331 0 0 1 4.322 4.322 4.33 4.33 0 0 1-4.322 4.322 4.33 4.33 0 0 1-4.322-4.322 4.317 4.317 0 0 1 4.322-4.322Z"
      fill="#051513"
    />
    <path
      d="M144.208 100.077c22.603 0 40.926-18.323 40.926-40.925 0-22.603-18.323-40.925-40.926-40.925-22.602 0-40.925 18.322-40.925 40.925 0 22.602 18.323 40.925 40.925 40.925Z"
      fill="#00D37E"
    />
    <path
      d="M142.59 56.458c6.713-3.873 7.35-9.417 8.216-14.386.522-2.997.741-4.166.741-4.166h11.892s-.564 3.184-1.086 6.18c-.867 4.97-.731 8.583-7.225 12.362-.135.073-9.312 5.377-9.312 5.377-6.713 3.873-7.35 9.416-8.217 14.386-.522 2.996-.741 4.166-.741 4.166h-11.891s.564-3.185 1.086-6.18c.866-4.97.73-8.583 7.224-12.362.146-.073 9.313-5.377 9.313-5.377Z"
      fill="#fff"
    />
    <path
      d="M139.864 54.964h-4.865a8.357 8.357 0 0 1-8.237-6.911l-1.785-10.127h11.891l2.996 17.038ZM148.541 63.34h4.865a8.357 8.357 0 0 1 8.237 6.911l1.786 10.127h-11.892l-2.996-17.038Z"
      fill="#fff"
    />
  </svg>
);

export default SvgFee;
